<div *ngIf="deliveryOrderDetails" class="people-section">
	<mat-accordion class="people-accordion">
		<mat-expansion-panel class="people-panel">
			<mat-expansion-panel-header>
				<mat-panel-title class="panel-title">
					<span class="flex align-items-center gap-2 w-full">
						<mat-icon class="people-icon">person</mat-icon>
						<span class="font-bold">Customer</span>
					</span>
				</mat-panel-title>
			</mat-expansion-panel-header>

			<div class="people-content">
				<div class="flex align-items-end gap-3 mb-4">
					<img class="user-img"
						 *ngIf="customerImageUrl; else placeholder"
						 [src]="customerImageUrl" />
					<ng-template #placeholder>
						<img class="user-img" src="/XpressApp/assets/images/avatar_placeholder.svg" />
					</ng-template>

					<div class="flex flex-column">
						<div class="user-name mb-1">
							{{ customerDisplayName | textTransform:TextTransformType.Titlecase }}
						</div>
						<div class="user-phone">{{ customerDisplayPhone }}</div>
					</div>
				</div>

				<div class="details-grid">
					<ng-container *ngIf="!isDefaultGuestBackedCustomer; else guestBackedCustomerInfo">
						<div class="flex align-items-center py-3">
							<div class="field-name w-6">Sign up date:</div>
							<div class="field-value w-6">{{ deliveryOrderDetails.UserCreatedAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }} ({{ deliveryOrderDetails.UserSignUpDaysPassed }} days)</div>
						</div>
						<div class="flex align-items-center py-3">
							<div class="field-name w-6">Rating:</div>
							<div class="field-value w-6">
								<span class="star-icon">&#9733;</span> {{ userRatingFormatted }}
							</div>
						</div>
						<div class="flex align-items-center py-3">
							<div class="field-name w-6">Account:</div>
							<div class="field-value w-6">
								<span class="lm-active-order-link">{{ (deliveryOrderDetails.LoginProvider || 'Xpress') | textTransform:TextTransformType.Titlecase }}</span>
							</div>
						</div>
						<div class="flex align-items-center py-3">
							<div class="field-name w-6">Application:</div>
							<div class="field-value w-6">
								<span class="badge xpress-app">{{ 'Xpress App' | textTransform:TextTransformType.Titlecase }}</span>
							</div>
						</div>
						<ng-container *ngIf="!isCustomerStatisticsLoading; else customerStatisticsSkeleton">
							<div class="flex align-items-center py-3 border-booking">
								<div class="field-name w-6">Bookings:</div>
								<div class="field-value w-6">{{ deliveryOrderDetails.BookingsCount || '--' }}</div>
							</div>
							<div class="flex align-items-center py-3">
								<div class="field-name w-6">Completed:</div>
								<div class="field-value w-6">{{ deliveryOrderDetails.CompletedCount || '--' }} ({{ deliveryOrderDetails.CompletedPercent || '--' }}%)</div>
							</div>
							<div class="flex align-items-center py-3">
								<div class="field-name w-6">Spend:</div>
								<div class="field-value w-6">{{ deliveryOrderDetails.TotalSpend | formatCurrency | textTransform:TextTransformType.Titlecase }}</div>
							</div>
						</ng-container>
						<ng-template #customerStatisticsSkeleton>
							<div class="flex align-items-center py-3 border-booking">
								<div class="field-name w-6">Bookings:</div>
								<div class="field-value w-6 flex justify-content-end">
									<p-skeleton width="3rem" height="1.25rem"></p-skeleton>
								</div>
							</div>
							<div class="flex align-items-center py-3">
								<div class="field-name w-6">Completed:</div>
								<div class="field-value w-6 flex justify-content-end">
									<p-skeleton width="5.5rem" height="1.25rem"></p-skeleton>
								</div>
							</div>
							<div class="flex align-items-center py-3">
								<div class="field-name w-6">Spend:</div>
								<div class="field-value w-6 flex justify-content-end">
									<p-skeleton width="4.5rem" height="1.25rem"></p-skeleton>
								</div>
							</div>
						</ng-template>
					</ng-container>
					<ng-template #guestBackedCustomerInfo>
						<div class="flex align-items-center py-3">
							<div class="field-name w-6">Booking source:</div>
							<div class="field-value w-6">
								<span class="badge xpress-app">{{ guestBackedCustomerSource }}</span>
							</div>
						</div>
						<div class="flex align-items-center py-3 border-booking">
							<div class="field-name w-6">Customer profile:</div>
							<div class="field-value w-6">N/A</div>
						</div>
					</ng-template>
					<div class="flex align-items-center py-3">
						<div class="field-name w-6">Priority:</div>
						<div class="field-value">
							<div class="badge regular" [ngClass]="{'vip': deliveryOrderDetails.IsPriority}">
								{{ (deliveryOrderDetails.IsPriority ? 'VIP' : 'Regular') | textTransform:TextTransformType.Titlecase }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>

		<mat-expansion-panel class="people-panel">
			<mat-expansion-panel-header>
				<mat-panel-title class="panel-title">
					<span class="flex align-items-center gap-2 w-full">
						<mat-icon class="people-icon">local_taxi</mat-icon>
						<span class="font-bold">Driver</span>
					</span>
				</mat-panel-title>
			</mat-expansion-panel-header>

			<div class="people-content">
				<!-- Profile Image and Name Section -->
				<div class="flex align-items-end gap-3 mb-4">
					<img class="user-img"
						 *ngIf="deliveryOrderDetails.RiderImageUrl; else placeholder"
						 [src]="deliveryOrderDetails.RiderImageUrl" />
					<ng-template #placeholder>
						<img class="user-img" src="/XpressApp/assets/images/avatar_placeholder.svg" />
					</ng-template>

					<div class="flex flex-column">
						<div class="user-name mb-1">
							{{ deliveryOrderDetails.RiderFirstName | textTransform:TextTransformType.Titlecase }} {{ deliveryOrderDetails.RiderLastName | textTransform:TextTransformType.Titlecase }}
						</div>
						<div class="user-phone">{{ deliveryOrderDetails.RiderPhone || 'N/A' }}</div>
					</div>
				</div>

				<div class="details-grid">
					<div class="flex align-items-center py-3">
						<div class="field-name w-6">Sex:</div>
						<div class="field-value w-6">{{ deliveryOrderDetails.RiderGender | textTransform:TextTransformType.Titlecase:'N/A' }}</div>
					</div>
					<div class="flex align-items-center py-3">
						<div class="field-name w-6">Email:</div>
						<div class="field-value w-6">{{ deliveryOrderDetails.RiderEmail | textTransform:TextTransformType.Titlecase:'N/A' }}</div>
					</div>
					<div class="flex align-items-center py-3">
						<div class="field-name w-6">Date of Birth:</div>
						<div class="field-value w-6">{{ deliveryOrderDetails.RiderBirthDate | formatDate:'ddd., MMMM D, YYYY, HH:mm' }}</div>
					</div>
					<div class="flex align-items-center py-3">
						<div class="field-name w-6">Full Profile:</div>
						<div class="field-value">
							<span class="lm-active-order-link">{{ 'View' | textTransform:TextTransformType.Titlecase }}</span>
						</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>
